var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{staticStyle:{"z-index":"11000"},attrs:{"position":"top center","duration":-1,"width":450,"classes":"mr-notification"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }